var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendedThumb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.496,
    height: 22.158,
    viewBox: "0 0 25.496 22.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 25.496,
    height: 22.158,
    transform: "translate(0 0)",
    fill: "#065683"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5328",
    "data-name": "Path 5328",
    d: "M25.1,8.977a3.985,3.985,0,0,0-3.912-2.19c-.109,0-.216,0-.325,0-.426.008-.853.011-1.281.011l-.557,0a7.687,7.687,0,0,0-.146-2.009,6.942,6.942,0,0,0-1.7-3.6A4.366,4.366,0,0,0,14.154,0a3.8,3.8,0,0,0-2.733,1.08,3.556,3.556,0,0,0-1.009,2.551l.006.651c0,.361,0,.724,0,1.1-.368.611-.913,1.508-1.491,2.431L8.709,7.8c-.827-.024-1.675-.034-2.75-.034l-2.731.006A3,3,0,0,0,.99,8.752,4.568,4.568,0,0,0,.016,12.1c.035.414.063.808.089,1.2l.276,3.733c.051.725.109,1.547.2,2.371a2.926,2.926,0,0,0,3.1,2.751l2.265,0,3.036,0A4.263,4.263,0,0,0,10.27,22l.547-.169a4.3,4.3,0,0,0,.677.054h.05c1.126-.011,2.252-.014,3.378-.014l4.219,0a4.461,4.461,0,0,0,4.514-4.427,4.282,4.282,0,0,0,.6-2.267,3.809,3.809,0,0,0,.625-2.376A3.925,3.925,0,0,0,25.1,8.977M9.143,19.476H3.685c-.389,0-.406-.036-.442-.362-.08-.747-.135-1.507-.188-2.243L3,16.084c-.061-.821-.122-1.64-.181-2.464-.018-.238-.036-.477-.053-.72l0-.031c-.023-.318-.047-.642-.074-.981a2.118,2.118,0,0,1,.271-1.321.336.336,0,0,1,.27-.112q.694,0,1.389,0h.077c.429,0,.863,0,1.3,0,.884,0,1.607.007,2.259.023Zm13.029-6.632h0a1.264,1.264,0,0,1-.375,1.181,1.255,1.255,0,0,0-.239.881,1.669,1.669,0,0,1-.362,1.385,1.113,1.113,0,0,0-.236.819,1.848,1.848,0,0,1-.424,1.48,1.827,1.827,0,0,1-1.4.608c-.721,0-1.441,0-2.162,0h-.513c-1.622,0-3.3,0-4.944.015a1.548,1.548,0,0,1-.9-.257l-.81-8.2a1.569,1.569,0,0,0,.877-.712c.788-1.234,1.543-2.477,2.249-3.645a1.424,1.424,0,0,0,.162-.72c0-.456,0-.915,0-1.373q0-.344,0-.689a.82.82,0,0,1,.512-.832,1.7,1.7,0,0,1,1.706.331,4.612,4.612,0,0,1,.945,2.225,5.986,5.986,0,0,1-.218,2.986,3.789,3.789,0,0,0-.1.408l-.007.039a.517.517,0,0,0,.018.3c0,.011.008.025.012.043l.074.3.424.033c.131.011.27.023.408.023.428,0,.857,0,1.286.006h.056c.885.007,1.8.013,2.7-.006.873-.013,1.467.025,1.761.651a1.269,1.269,0,0,1-.2,1.461,1.2,1.2,0,0,0-.3,1.264",
    transform: "translate(0 0)",
    fill: "#065683"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendedThumb);
export default __webpack_public_path__ + "static/media/recommended-thumb.4a37fc0a857cc66bc69ba607047dc9b5.svg";
export { ForwardRef as ReactComponent };